/**
 * Created by Kaku.Guo on 2018/11/23.
 */
import React, {useState} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {getMessage, Link} from '../../index';
import AssetDetailInfo from './AssetDetailInfo';
import AssetDetailRating from './AssetDetailRating';
import {LauncherIntegrationUtils} from 'epic-launcher-integration/app/scripts';

const AssetDetailContent = props => {
    const {data = {}, messages, isLinkSeller, locale} = props;
    const {title, seller, effectiveDate, description, customAttributes, compatibleApps} = data;
    const hasBuyLink = customAttributes && 'BuyLink' in customAttributes;
    const [compatibility, setCompatibility] = useState('');
    LauncherIntegrationUtils.checkItemCompatibility(compatibleApps, compatibilityResult => {
        if (compatibilityResult && compatibility !== compatibilityResult) {
            setCompatibility(compatibilityResult);
        }
    });

    const compatMsgProp = compatibility.replace(/-/g, '_');
    let iconClass = '';
    if (compatibility === 'no-engine') {
        iconClass = 'fa-minus-circle';
    } else if (compatibility === 'incompatible') {
        iconClass = 'fa-exclamation-circle';
    } else if (compatibility === 'partial') {
        iconClass = 'fa-info-circle';
    } else if (compatibility === 'compatible') {
        iconClass = 'fa-check-circle';
    }

    return (
        <div className="asset-details__content">
            <div className="asset-detail-full">
                <div className="pull-left">
                    <h1 className="post-title">{title}</h1>
                </div>
                <div className={`pull-right compatibility ${!compatibility ? 'hidden' : ''}`}>
                    <i
                        className={`fa fa-2x ${iconClass} ${compatibility}`}
                        title={getMessage(
                            messages,
                            `messages.com.epicgames.plugin.store.launcher.${compatMsgProp}`
                        )}
                    />
                </div>
                <div className="clearfix" />
                {seller && (
                    <div className="asset-desc-nvs">
                        <span className="seller-name">
                            {isLinkSeller ? (
                                <Link to={`profile/${seller.name.replace(/ /g, '+')}`}>
                                    {seller.name}
                                </Link>
                            ) : (
                                seller.name
                            )}
                        </span>
                        {effectiveDate && (
                            <span className="">
                                &nbsp;-{' '}
                                {moment(effectiveDate)
                                    .locale(locale)
                                    .format('MMM D, YYYY')}
                            </span>
                        )}
                    </div>
                )}
                <AssetDetailRating external={hasBuyLink} />
                <p className="asset-detail-text">{description}</p>
            </div>
            <AssetDetailInfo {...props} />
        </div>
    );
};
AssetDetailContent.propTypes = {
    data: PropTypes.object,
    messages: PropTypes.object,
    isLinkSeller: PropTypes.bool,
    locale: PropTypes.string
};
export default AssetDetailContent;
